import Link from 'next/link';
import { NextImage } from 'src/components/shared/elements/NextImage';
import { mixpanel } from 'src/utils/mixpanel';

type Props = {
  isDown: boolean;
  bottomMenuItems: {
    route: string;
    imageSrc?: string;
    iconComponent?: React.ReactNode;
    title: string;
    event: string;
    badge?: string;
    onClick?: () => void;
  }[];
};

export const Presenter: React.FC<Props> = ({ isDown, bottomMenuItems }) => (
  <nav
    className={`w-full h-[92px] bg-white transition-all duration-200 ease-in-out fixed left-0 bottom-0 right-0 z-50 shadow-top ${isDown ? '' : 'shadow-none translate-y-full'} semiLg:hidden`}
  >
    <ul className="bg-white px-2 pt-2 pb-5 flex justify-evenly items-start">
      {bottomMenuItems.map((item, index) => (
        <li key={index} className="flex justify-center items-center text-center flex-1">
          {item.route === '#' ? (
            <button
              className="relative inline-block"
              onClick={() => {
                item.onClick?.();
                mixpanel.onBottomMenuTapped(item.event);
              }}
            >
              <div className="w-9 h-9 grid place-content-center">{item.iconComponent}</div>
              <p className="text-xxs">{item.title}</p>
            </button>
          ) : (
            <Link href={item.route}>
              <a
                className="relative w-full flex flex-col items-center max-w-[60px]"
                onClick={() => mixpanel.onBottomMenuTapped(item.event)}
              >
                {item.iconComponent ? (
                  <div className="relative">
                    {item.iconComponent}
                    {item.badge && (
                      <span className="grid place-content-center absolute -top-1 -right-1 w-4 h-4 rounded-full bg-primary text-xs text-white">
                        {item.badge}
                      </span>
                    )}
                  </div>
                ) : (
                  <div className="relative">
                    <div className="w-9 h-9 grid place-content-center">
                      <NextImage src={item.imageSrc ?? ''} alt="" width={36} height={36} />
                    </div>
                  </div>
                )}
                <p className="text-xxs">{item.title}</p>
              </a>
            </Link>
          )}
        </li>
      ))}
    </ul>
  </nav>
);
